import { render } from "./InstituteEmployee.vue?vue&type=template&id=ebcb6396&ts=true"
import script from "./InstituteEmployee.vue?vue&type=script&lang=ts"
export * from "./InstituteEmployee.vue?vue&type=script&lang=ts"

import "./InstituteEmployee.vue?vue&type=style&index=0&id=ebcb6396&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__